import React, { createRef } from 'react';
import { Whisper, IconButton, RadioGroup, Radio, Divider, Checkbox } from 'rsuite';
import iconPreference from '../../../../../../assets/icons/icon_preference.svg';
import styles from './styles.module.scss';
import { useAderenciaPreference } from '../../hooks/useAderenciaPreference';
import { LoadingSpinerLocal } from '../../../../../../components';

type FilterPreferenceProps = {
  className?: string;
  onChangePreference?: () => void;
};

export const FilterPreference = ({ className, onChangePreference }: FilterPreferenceProps) => {
  const popoverRef = createRef();
  const { handleChangeAderenciaPreferences, handleChangeCanalPreferences, aderenciaPreferenceData, loadingSavePreference } = useAderenciaPreference();

  const handlePriceType = (value: string) => {
    handleChangeAderenciaPreferences('tipoPreco', value);
    onChangePreference?.();
  };

  const handleChannel = (name: 'canalFisico' | 'canalDigital', value: boolean) => {
    handleChangeCanalPreferences(name, !value);
    onChangePreference?.();
  };
  return (
    <Whisper
      placement="bottomEnd"
      trigger="click"
      triggerRef={popoverRef}
      speaker={
        <div className={styles['preference-popover']}>
          <LoadingSpinerLocal loading={loadingSavePreference} size="md" />

          <div className={styles['form-wrapper']}>
            <p className={styles['popover-title']}>TIPO DE PREÇO</p>
            <RadioGroup name="tipoPreco" onChange={value => handlePriceType(value)} value={aderenciaPreferenceData?.tipoPreco}>
              <Radio value="PRECO_PAGO">
                <p className={styles['input-title']}>Preço pago</p>
                <p className={styles['input-subtitle']}>Preço efetivamente pago pelo usuário no varejo, podendo ser promoção.</p>
              </Radio>
              <Radio value="PRECO_REGULAR">
                <p className={styles['input-title']}>Preço regular</p>
                <p className={styles['input-subtitle']}>Preço original do produto, sem promoção e outros descontos.</p>
              </Radio>
            </RadioGroup>
            <Divider className={styles.divider} />
            <div className={styles['canal-title-wrapper']}>
              <p className={styles['popover-title']}>CANAL</p>
              <p className={styles['popover-subtitle']}>Selecione ao menos uma opção</p>
            </div>
            <Checkbox
              value={aderenciaPreferenceData?.canalFisico}
              checked={aderenciaPreferenceData?.canalFisico}
              onChange={value => handleChannel('canalFisico', value)}
            >
              <p className={styles['input-title']}>Canal físico</p>
              <p className={styles['input-subtitle']}>
                Preços praticados na loja física. Coletados diretamente do ponto de venda, de notas fiscais ou de apps quando correspondem aos preços da loja.
              </p>
            </Checkbox>
            <Checkbox
              value={aderenciaPreferenceData?.canalDigital}
              checked={aderenciaPreferenceData?.canalDigital}
              onChange={value => handleChannel('canalDigital', value)}
            >
              <p className={styles['input-title']}>Canal digital</p>
              <p className={styles['input-subtitle']}>Preços praticados em apps do varejo físico (iFood, Rappi, etc.).</p>
            </Checkbox>
          </div>
        </div>
      }
    >
      <IconButton
        className={`${styles['btn-preference']} ${className}`}
        appearance="subtle"
        placement="right"
        icon={<img alt="preferencias" src={iconPreference} />}
      >
        Preferências
      </IconButton>
    </Whisper>
  );
};
